Object.defineProperty(exports, "__esModule", { value: true });
function ExistsQuery(field) {
    return {
        exists: { field: field }
    };
}
exports.ExistsQuery = ExistsQuery;
//# sourceMappingURL=ExistsQuery.js.map


// WEBPACK FOOTER //
// ./src/core/query/query_dsl/term_level/ExistsQuery.js